export default "__VITE_ASSET__CXZsuGDu__"